import { Card, Grid } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import {
    Box, Typography, useCommonComponentContext
} from "@maysoft/common-component-react";

import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";
import PopupUser from "../CommunityChannel/poupUser";
import InfiniteScroll from "react-infinite-scroll-component";
import ReactionService from "../../services/message/ReactionService";
import ItemDetailPostComment from "../CommunityPost/itemDetailPostComment";
import PopupCreateUpdatePost from "../CommunityPost/popupCreateUpdatePost";
import CommunityPostService from "../../services/message/CommunityPost.service";
import PopupItemDetailPostComment from "../CommunityPost/popupItemDetailPostComment";

import { IRecordPost } from "../../containers/post/usePost";
import { CommentProvider } from "../../providers/CommentProvider";
import { ICommunityPostDetail } from "../../containers/channel/useChannel";
import { useCommunityCommonContext } from "../../providers/CommunityCommonProvider";
import { ICodename, IPagedList, IReaction, IUserComment } from "../../commons/interfaces";



const CommunityPostFollowComponent = () => {

    const Strings = useStrings();

    const {
        axios,
        clientId,
        userInfo,
        tenantCode,
        serviceCode,
        onError,
        onHideLoading,
        onShowLoading,
    } = useCommonComponentContext();

    const propsData = useCommunityCommonContext();

    const [loading, setLoading] = useState(false);
    const [reactionIcons, setReactionIcons] = useState<IReaction[]>([]);
    const [dataGetPagePosts, setDataGetPagePosts] = useState<IPagedList<ICommunityPostDetail>>({
        hasNext: false,
        hasPrevious: false,
        pageSize: 0,
        totalPages: 0,
        totalCount: 0,
        currentPage: 0,
        items: [],
    });

    const [modelUserDrawer, setModelUserDrawer] = useState<{ open: boolean, data?: IUserComment }>({ open: false, data: undefined });
    const [modelPopupCreateUpdatePost, setModelPopupCreateUpdatePost] = useState<{ open: boolean, data?: IRecordPost }>({ open: false, data: undefined });
    const [modelDialogPostComment, setModelDialogPostComment] = useState<{ open: boolean, data?: ICommunityPostDetail }>({ open: false, data: undefined });

    const listChannels = useMemo(() => (
        [...propsData.listChannels || []].map(item => ({ code: item.id, name: item.name } as ICodename))
    ), [propsData.listChannels]);

    useEffect(() => {
        const getAllReactionIcon = async () => {
            try {
                const result = await ReactionService.getAll();
                setReactionIcons(result);
            } catch (error) {
                setReactionIcons([]);
            }
        };
        getAllReactionIcon();
    }, []);

    useEffect(() => {
        (async () => {
            onShowLoading();

            setDataGetPagePosts({
                hasNext: false,
                hasPrevious: false,
                pageSize: 0,
                totalPages: 0,
                totalCount: 0,
                currentPage: 0,
                items: [],
            });

            await getPagedPostFollow({ pageNumber: 1 });

            onHideLoading();
        })();
    }, [propsData.communityId]);

    const getPagedPostFollow = async (req: { idChannel?: string, pageNumber?: number }) => {
        try {
            setLoading(true);

            const resultGetPage = await CommunityPostService.getPaged({
                isFollowing: true,
                pageSize: 2,
                pageNumber: req?.pageNumber || 1,
            });

            setDataGetPagePosts((prev) => ({
                ...prev,
                ...resultGetPage,
                items: [...prev.items, ...resultGetPage.items],
            }));

            setLoading(false);
        } catch (error) {
            setLoading(false);
            onHideLoading();
            const err = Helpers.renderExceptionError(error);
            onError(err);
        }
    }

    // Box loading
    const renderBoxLoading = () => {
        let value = "";
        if ([...dataGetPagePosts?.items || []].length === 0) {
            value = Strings.Common.NO_DATA;
        } else {
            if (dataGetPagePosts.totalCount !== [...dataGetPagePosts?.items || []].length) {
                value = Strings.Common.LOADING;
            } else {
                value = "";
            }
        }

        return (
            <Box sx={{
                width: "100%",
                padding: "1rem",
                display: "flex",
                alignItems: "end",
                justifyContent: "center",
                height: ([...dataGetPagePosts?.items || []].length === 0) ? "90%" : undefined,
            }}>
                {
                    loading
                        ? <Typography variant="caption" fontWeight="bold">
                            {Strings.Common.LOADING}
                        </Typography>
                        : <Typography variant="caption" fontWeight="bold">
                            {value}
                        </Typography>
                }
            </Box>
        );
    }

    return (
        <CommentProvider
            value={{
                axios: axios,
                clientId: clientId,
                tenantCode: tenantCode,
                serviceCode: serviceCode,
                organizationId: userInfo?.userProfile?.organizationId,
                userLogin: {
                    role: undefined,
                    avatarUrl: userInfo?.userProfile?.avatarUrl,
                    avatarId: userInfo?.userProfile?.avatarId,
                    userName: userInfo?.userProfile?.userName,
                    fullName: userInfo?.userProfile?.fullName,
                    userId: userInfo?.userProfile?.identityId,
                },

                isManager: false,
                hiddenComment: false,
                reactionIcons: reactionIcons,
                referenceId: modelDialogPostComment?.data?.id || "",

                onClickShowProfile(data) {
                    setModelUserDrawer({
                        data: data,
                        open: !Helpers.isNullOrEmpty(data.userId),
                    })
                },
            }}
        >
            {/* View Popup User Profile  */}
            <PopupUser
                dataUser={modelUserDrawer?.data}
                openDrawer={modelUserDrawer?.open}
                onCloseDrawer={() => {
                    setModelUserDrawer({ ...modelUserDrawer, open: false });
                }}
            />

            <>
                {/* Popup Create or Update Post */}
                <PopupCreateUpdatePost
                    listChannels={listChannels || []}
                    open={modelPopupCreateUpdatePost?.open}
                    dataDetailPost={modelPopupCreateUpdatePost?.data}
                    channelId={modelPopupCreateUpdatePost?.data?.channelId}
                    onAction={(isCreate, data) => {
                        let newListTemp = [...dataGetPagePosts?.items || []];

                        if (isCreate) {
                            newListTemp.push(data);
                        } else {
                            const indexTemp = newListTemp.findIndex(item => item.id === data.id);
                            if (indexTemp !== -1) {
                                if (newListTemp[indexTemp]?.isFollowed) {
                                    newListTemp = newListTemp.filter(item => item.id !== data.id);
                                } else {
                                    newListTemp[indexTemp] = data;
                                }
                            }
                        }

                        setDataGetPagePosts({ ...dataGetPagePosts, items: newListTemp });

                        setModelPopupCreateUpdatePost({ open: false, data: undefined });
                    }}
                    onClose={() => {
                        setModelPopupCreateUpdatePost({ open: false, data: undefined });
                    }}
                />

                {/* View Popup Item Detail Post Comment */}
                <PopupItemDetailPostComment
                    openPopup={modelDialogPostComment.open}
                    dataDetailPost={modelDialogPostComment?.data}

                    onClose={(data) => {
                        let newListTemp = [...dataGetPagePosts?.items || []];

                        const indexTemp = newListTemp.findIndex(item => item.id === data.id);

                        if (indexTemp !== -1) {
                            newListTemp[indexTemp] = data;
                        }

                        setDataGetPagePosts({ ...dataGetPagePosts, items: newListTemp });

                        setModelDialogPostComment({ open: false, data: undefined });
                    }}

                    onShowUserProfile={(data) => {
                        setModelUserDrawer({
                            data: data,
                            open: !Helpers.isNullOrEmpty(data?.userId),
                        });
                    }}

                    onEditPost={(data) => {
                        setModelPopupCreateUpdatePost({
                            open: true,
                            data: data,
                        });
                    }}
                />

                <InfiniteScroll
                    style={{ backgroundColor: "transparent" }}
                    dataLength={[...dataGetPagePosts.items || []].length}
                    hasMore={dataGetPagePosts.hasNext}
                    loader={renderBoxLoading()}
                    next={async () => {
                        if (dataGetPagePosts.hasNext) {
                            const value = (dataGetPagePosts.currentPage || 0) + 1;
                            getPagedPostFollow({ pageNumber: value });
                        }
                    }}
                >
                    <Grid container spacing={2}>
                        {/* List Item Post in Channel */}
                        {
                            [...dataGetPagePosts.items || []].map(item => (
                                <Grid item xs={12} key={item.id}>
                                    <Card>
                                        <ItemDetailPostComment
                                            isDetail={false}
                                            dataDetail={item}
                                            onShowUserProfile={(data) => {
                                                setModelUserDrawer({
                                                    data: data,
                                                    open: !Helpers.isNullOrEmpty(data?.userId),
                                                });
                                            }}
                                            onEditPost={(data) => {
                                                setModelPopupCreateUpdatePost({
                                                    open: true,
                                                    data: data,
                                                });
                                            }}
                                            onClickBox={(data) => {
                                                setModelDialogPostComment({
                                                    open: true,
                                                    data: data,
                                                });
                                            }}
                                            onCallBack={(data, isDelete) => {
                                                let newListTemp = [...dataGetPagePosts?.items || []];

                                                if (isDelete) {
                                                    newListTemp = newListTemp.filter(item => item.id !== data.id);
                                                } else {
                                                    const indexTemp = newListTemp.findIndex(item => item.id === data.id);

                                                    if (indexTemp !== -1) {
                                                        if (newListTemp[indexTemp]?.isFollowed) {
                                                            newListTemp = newListTemp.filter(item => item.id !== data.id);
                                                        } else {
                                                            newListTemp[indexTemp] = data;
                                                        }
                                                    }
                                                }

                                                setDataGetPagePosts({ ...dataGetPagePosts, items: newListTemp });
                                            }}
                                        />
                                    </Card>
                                </Grid>
                            ))
                        }
                    </Grid>
                </InfiniteScroll>
            </>
        </CommentProvider>
    );
};

export default CommunityPostFollowComponent;
